import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { PRICE_CHANGE_TYPES } from '../../../common/constants';
import { WeekdayPriceChangeRuleItem } from '../../../common/types/rates.types';

function WeekdayPriceChangeRulesForm({
  addOrUpdateRule,
  removeRule,
  handleInputChange,
  handleSelectChange,
  selectedWeekday,
  data,
  hasWriteAccess,
  isDefaultRate = false,
}: {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  addOrUpdateRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  removeRule: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleSelectChange: any;
  selectedWeekday: number;
  data: WeekdayPriceChangeRuleItem;
  hasWriteAccess: boolean;
  isDefaultRate?: boolean;
}) {
  const priceChangeOptions = PRICE_CHANGE_TYPES.map(priceChangeType => {
    return {
      value: priceChangeType.priceChangeType,
      label: priceChangeType.description,
    };
  });

  return (
    <>
      <Form.Group className="mb-24">
        <Form.Label>Hinnan muutoksen tyyppi</Form.Label>
        <Select
          inputId="priceChangeType"
          name="priceChangeType"
          placeholder="Valitse tyyppi..."
          isClearable
          isSearchable
          options={priceChangeOptions}
          onChange={option => handleSelectChange(option, 'priceChangeType')}
          value={priceChangeOptions.filter(
            option => option.value === data.priceChangeType,
          )}
          classNames={{
            control: state => 'form-control form-control-react-select',
          }}
          isDisabled={!hasWriteAccess}
        />
      </Form.Group>

      {data.priceChangeType === 1 && (
        <Form.Group controlId="difference" className="mb-24">
          <Form.Label>Hinnan kiinteä muutos</Form.Label>
          <Form.Control
            type="text"
            name="difference"
            onChange={handleInputChange}
            value={data.difference || ''}
            readOnly={!hasWriteAccess}
          />
        </Form.Group>
      )}

      {data.priceChangeType === 2 && (
        <Form.Group controlId="percent" className="mb-24">
          <Form.Label>Hinnan prosentuaalinen muutos</Form.Label>
          <Form.Control
            type="text"
            name="percent"
            onChange={handleInputChange}
            value={data.percent || ''}
            readOnly={!hasWriteAccess}
          />
        </Form.Group>
      )}

      {isDefaultRate ? (
        <>
          <input type="hidden" name="isActive" value="true" />
          <input type="hidden" name="isCopyable" value="true" />
        </>
      ) : (
        <Row xs="auto">
          <Col>
            <Form.Group controlId="isActive" className="mb-24">
              <Form.Label>Aktiivinen sääntö</Form.Label>
              <Form.Check
                type="checkbox"
                name="isActive"
                onChange={handleInputChange}
                checked={data.isActive}
                disabled={!hasWriteAccess}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="isCopyable" className="mb-24">
              <Form.Label>Kopioitava sääntö</Form.Label>
              <Form.Check
                type="checkbox"
                name="isCopyable"
                onChange={handleInputChange}
                checked={data.isCopyable}
                disabled={!hasWriteAccess}
              />
            </Form.Group>
          </Col>
        </Row>
      )}

      {hasWriteAccess && (
        <div className="my-24">
          <Button
            variant="blue"
            className="me-8 mb-8"
            onClick={addOrUpdateRule}
          >
            Lisää / muokkaa sääntöä
          </Button>
          <Button variant="danger" className="me-8 mb-8" onClick={removeRule}>
            Poista sääntö
          </Button>
        </div>
      )}
    </>
  );
}

export default WeekdayPriceChangeRulesForm;
